export default class ExitFullScreen {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.exitFullScreen();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            default:
                event["exitFullScreen"] = this._default;
        }

        return event;
    }
}
